import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { useBoolean, useRecentGetter } from '@lib/common';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSubject } from '@lib/common/hooks/use-subject';
import { BadgesMaster } from '@api/masters';
import fuzzysort from 'fuzzysort';
import { useSubscription } from '@lib/common/hooks/use-subscription';
import { debounceTime, switchMap } from 'rxjs/operators';
import { asyncScheduler } from 'rxjs';
import { BadgeDialogContent } from './BadgesDialogContent_v2';
import { CompanyBadge } from '@lib/company';

export const BadgesPicker = ({
  badges,
  onBadgeAdd = null,
  onBadgeEdit = null,
  badgeEditState = false,
  editBadgeScenario = false,
  editBadgeIndex = null,
  editBadgeData = null,
  setEachBadgeEdit = null,
  isLock=true,
}: {
  badges: BadgesMaster[];
  onBadgeAdd?: (badge: CompanyBadge) => any;
  onBadgeEdit?: (badge: CompanyBadge, idx?: number) => any;
  badgeEditState?: boolean;
  editBadgeScenario?: boolean;
  editBadgeIndex?: number;
  editBadgeData?: CompanyBadge;
  setEachBadgeEdit?: (editingBadge: boolean) => any;
  isLock?: boolean
}) => {
  const [badgeOptions, setServiceOptions] =
    useState<Array<BadgesMaster & { highlighted?: string }>>(badges);

  useEffect(() => {
    setServiceOptions(badges);
  }, [badges]);

  const [dialogOpen, openDialog, closeDialog] = useBoolean(false);
  useEffect(() => {
    if (badgeEditState) openDialog();
  }, [badgeEditState]);
  const searchTargets = useMemo(
    () => badges.map(s => ({ ...s, prepared: fuzzysort.prepare(s.badge_name) })),
    [badges]
  );

  const resetResults = () => {
    setServiceOptions(badges);
  };

  const state = useRecentGetter({ searchTargets, setServiceOptions, badgeOptions, resetResults });

  const search$ = useSubject<string>();

  useSubscription(() =>
    search$
      .pipe(
        debounceTime(300, asyncScheduler),
        switchMap(txt =>
          !txt.trim()
            ? Promise.resolve(null)
            : fuzzysort.goAsync(txt, state().searchTargets, {
                key: 'prepared',
                limit: 50,
                threshold: -1000,
              })
        )
      )
      .subscribe(results => {
        if (!results) {
          return state().resetResults();
        }

        state().setServiceOptions(
          results.map(r => ({
            ...r.obj,
            highlighted: fuzzysort.highlight(r, '<strong>', '</strong>'),
          }))
        );
      })
  );

  const onSearch = useCallback(
    evt => {
      search$.next(evt.target.value);
    },
    [search$]
  );

  const handleBadgeClick = (srv: CompanyBadge) => {
    closeDialog();
    setTimeout(() => {
      if (editBadgeScenario)
        onBadgeEdit &&
          onBadgeEdit(
            {
              badge_master_vtr_id: srv.badge_master_vtr_id,
              badge_name: srv.badge_name,
              publish: srv.publish ? true : false,
              vtr_id: srv.vtr_id,
              parameter_values_json: srv.parameter_values_json,
              source: 'DELI',
              // entity_type:'company'
            },
            editBadgeIndex
          );
      else
        onBadgeAdd &&
          onBadgeAdd({
            badge_master_vtr_id: srv.badge_master_vtr_id,
            badge_name: srv.badge_name,
            publish: srv.publish ? true : false,
            vtr_id: srv.vtr_id,
            parameter_values_json: srv.parameter_values_json,
            source: 'DELI',
            // entity_type:'company'
          });
      setOkPressed(false);
    }, 100);
  };
  const [OkPressed, setOkPressed] = useState(false);
  return (
    <>
      {!editBadgeScenario && (
        <Button onClick={openDialog} color="primary" variant="contained" disabled={isLock}>
          Add
        </Button>
      )}
      <Dialog
        // Disable transitions to speed up the element interaction
        // and fix multiple addtion on consecutive clicks.
        transitionDuration={0}
        fullWidth
        maxWidth="sm"
        open={dialogOpen}
        onClose={() => {
          setEachBadgeEdit && setEachBadgeEdit(false);
          closeDialog();
        }}>
        <DialogTitle>Add/Edit badges</DialogTitle>
        <DialogContent style={{ height: '65vh' }} dividers>
          <BadgeDialogContent
            badgeOptions={badgeOptions}
            badgesLength={badges.length}
            onSearch={onSearch}
            handleBadgeClick={handleBadgeClick}
            defaultValue={editBadgeData}
            OkPressed={OkPressed}
            setOkPressed={setOkPressed}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOkPressed(true)}>Ok</Button>
          <Button
            onClick={() => {
              setEachBadgeEdit && setEachBadgeEdit(false);
              closeDialog();
            }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
